import { useQuery } from 'react-query'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import { request } from '../../sharedLegacy/utils/api'
import { getLiveId } from './roomInfo'
import { getLiveToken } from './useConnectInfo'
import {
  type APIResponse,
  HTTPMethod,
} from '../../sharedLegacy/utils/api.types'

interface LiveDataRequestParams {
  token?: string
  live_id: string
  include_stats_p: boolean
}

type LiveDataDTO = {
  before_webinar_countdown_p: boolean
  broadcasting_p: boolean
  cancelled_p: boolean
  comment_mode: string
  question_mode: string
  draft_p: boolean
  token: string
  duration_minutes: string
  live_format: string
  live_id: string
  live_label: string
  live_status: string
  locale: string
  name: string
  number_of_comments: string
  number_of_comments_fmt: string
  primary_timezone_live_date__date: string
  primary_timezone_live_date__time: string
  template_p: boolean
  description_html: string
}

const getQueryObj = (liveAuthToken?: string) => ({
  queryKey: ['live_data'],
  queryFn: async () => {
    const liveId = getLiveId()
    const params: LiveDataRequestParams = {
      live_id: `${liveId}`,
      include_stats_p: true,
    }

    if (liveAuthToken) {
      params.token = liveAuthToken
    }

    const response = await request<
      LiveDataRequestParams,
      APIResponse<LiveDataDTO[]>
    >({
      url: '/api/2/live/list',
      method: HTTPMethod.GET,
      data: params,
    })

    return response.data.at(0)
  },
  enabled: !!liveAuthToken,
  staleTime: Infinity,
  cacheTime: Infinity,
  refetchInterval: 10e3,
})

const useLiveDataQuery = () => {
  // TODO: refactor this in the future
  // We should have a global way to access the live token whether you are a presenter, producer or audience
  const [liveToken, setLiveToken] = useState<string | null>(null)

  useEffectOnce(() => {
    getLiveToken().then((token) => {
      setLiveToken(token)
    })
  })

  const queryObj = getQueryObj(liveToken ?? undefined)
  return useQuery(queryObj)
}

export { useLiveDataQuery }
